import CustomReportDatePopover from './CustomReportDatePopover'

export default CustomReportDatePopover



// WEBPACK FOOTER //
// ./src/legacy/containers/Popovers/CustomReportDatePopover/index.js